<template>
  <div
    v-if="data"
    class="service-request"
    :class="showModal ? 'active-modal' : ''"
  >
    <div class="container">
      <h1 class="uikit__h3" v-if="data.title">
        {{ data.title }}
      </h1>

      <form ref="form" class="service-request__form">
        <div class="service-request__info-block">
          <p class="service-request__info-block_label">
            {{ data.subtitle }}
          </p>
          <p class="service-request__info-block_number">
            {{ data.vin }}
          </p>
        </div>

        <div class="split2">
          <div class="service-request__form-col">
            <!-- <BaseSelect
              :labelText="data.form.appeal"
              :placeholder="data.form.appeal"
              :options="data.appeal"
              :defaultText="data.defaultText"
              class="select-city"
              @input="changeAppeal"
              :errorText="errors && errors.appeal ? errors.appeal[0] : ''"
            /> -->

            <BaseInput
              name="firstname"
              :labelText="data.form.firstname"
              :errorText="errors && errors.firstname ? errors.firstname[0] : ''"
            />

            <BaseInput
              name="lastname"
              :labelText="this.data.form.lastname"
              :errorText="errors && errors.lastname ? errors.lastname[0] : ''"
            />

            <BaseInput
              type="email"
              name="email"
              :labelText="data.form.email"
              :errorText="errors && errors.email ? errors.email[0] : ''"
            />

            <BaseInput
              name="phone"
              type="tel"
              v-mask="maskNumber"
              :labelText="data.form.phone"
              :errorText="errors && errors.phone ? errors.phone[0] : ''"
            />

            <BaseSelect
              :labelText="data.form.method"
              :placeholder="data.methodHint"
              :options="data.methods"
              :value="selectedMethod"
              @input="getMethodsId"
              :defaultText="data.defaultText"
              class="select-city"
              :errorText="errors && errors.method ? errors.method[0] : ''"
            />

            <BaseInput
              name="number"
              class="service-request__car-number"
              :mask="locale === 'ru' || locale === 'ro' ? '' : 'XXXXXXXX'"
              :labelText="data.form.number"
              :errorText="errors && errors.number ? errors.number[0] : ''"
            />

            <!-- <BaseInput
              name="middlename"
              :labelText="data.form.middlename"
              :errorText="
                errors && errors.middlename ? errors.middlename[0] : ''
              "
            /> -->

            <BaseSelect
              v-if="!queryCity"
              :labelText="data.form.city"
              :placeholder="data.form.city"
              :options="data.cities"
              :defaultText="data.defaultText"
              :value="
                queryCity !== ''
                  ? data.cities.find((city) => city.id === queryCity)
                  : null
              "
              :disabled="queryCity !== ''"
              @input="changeCity"
              class="select-city"
              :errorText="errors && errors.city ? errors.city[0] : ''"
            />

            <BaseSelect
              v-if="!queryDealer"
              :labelText="data.form.dealer"
              :placeholder="data.form.dealer"
              :defaultText="data.defaultText"
              :options="dillersArray"
              :value="
                dealerId !== ''
                  ? dillersArray.find((dealer) => +dealer.id === +dealerId)
                  : null
              "
              :disabled="!dillersArray.length"
              @input="getDealerId"
              ref="dillerDropdown"
              :class="{ deactive: isActive }"
              selectLabel="short_label"
              :errorText="errors && errors.dealer ? errors.dealer[0] : ''"
            />

            <BaseDatePicker
              ref="datePickerDefault"
              key="datePickerDefault"
              :label="data.form.requestedtime.label"
              :buttonsText="data.form.requestedtime.buttonsText"
              :options="datePickerOptions"
              :placeholder="data.form.requestedtime.placeholder"
              :lang="data.form.requestedtime.language"
              :errorText="
                errors && errors.requested_time ? errors.requested_time[0] : ''
              "
              required
              :class="[
                'service-request__form-input vin-label',
                'service-request__form-input_lgUp',
                { disabled: disabledCalendar },
              ]"
              @input="dateAndTime = $event"
            />

            <BaseDatePicker
              ref="datePicker"
              key="datePicker"
              required
              :label="data.form.requestedtime.label"
              :buttonsText="data.form.requestedtime.buttonsText"
              :options="datePickerOptions"
              :placeholder="data.form.requestedtime.placeholder"
              :lang="data.form.requestedtime.language"
              :errorText="
                errors && errors.requested_time ? errors.requested_time[0] : ''
              "
              :class="[
                'service-request__form-input vin-label',
                'service-request__form-input_lgDown',
                { disabled: disabledCalendar },
              ]"
              @input="dateAndTime = $event"
            />

            <BaseInput
              class="service-request__comment"
              type="text"
              name="comment"
              :labelText="data.form.comment"
              :errorText="errors && errors.comment ? errors.comment[0] : ''"
            />
          </div>
        </div>
        <div class="service-request__form-row split">
          <BaseCheckbox
            :labelText="data.form.agreement"
            :errorText="errors && errors.agreement ? errors.agreement[0] : ''"
            @check="checkboxValue"
            @click.native="openModal($event)"
          />
        </div>
        <div class="service-request__form-row split">
          <BaseCheckbox
            :labelText="data.form.marketing.consent"
            :errorText="errors && errors.marketing ? errors.marketing[0] : ''"
            @check="checkboxMarketingValue"
            @click.native="openModal($event)"
          />
        </div>
        <BaseBtn
          :type="submit"
          :class="[
            'service-request__form-btn',
            { 'service-request__form-btn_margin-for-calendar': !marginHidden },
          ]"
          @click.native.prevent="submit"
        >
          {{ data.form.button.text }}
        </BaseBtn>
      </form>
    </div>

    <BaseModal
      v-if="showModal"
      :content="popupContent"
      @close="showModal = false"
    >
      {{ data.closebuttontext }}
    </BaseModal>
  </div>
</template>

<script>
import BaseInput from "@/components/base/BaseInput";
import BaseCheckbox from "@/components/base/BaseCheckbox";
import BaseSelect from "@/components/base/BaseSelect";
import BaseBtn from "@/components/base/BaseBtn";
import BaseModal from "@/components/base/BaseModal";
import BaseDatePicker from "@/components/base/BaseDatePicker";
import axios from "axios";
import { mask, tokens } from 'vue-the-mask';
import { config } from "../config";
// import "FormData";
export default {
  name: "service_request",
 directives: { mask },
  components: {
    BaseInput,
    BaseCheckbox,
    BaseSelect,
    BaseBtn,
    BaseModal,
    BaseDatePicker,
  },
  props: {
    win: {
      type: String,
    },
    formInfoItems: {
      type: Array,
    },
    hint: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      data: null,
      dealer: null,
      dealerData: null,
      dealerTimeItems: [],
      dillersArray: [],
      cityId: null,
      dealerId: null,
      methodsId: null,
      selectedMethod: null,
      appealId: null,
      checkVal: 0,
      checkMarketingVal: 0,
      errors: null,
      showModal: false,
      isActive: true,
      locale: null,
      getUrl: null,
      maskNumber: null,
      searchVal: null,
      dateAndTime: null,
      disabledCalendar: true,
      marginHidden: true,
      queryCity: "",
      queryDealer: "",
      popupContent: "",
    };
  },

  computed: {
    datePickerOptions() {
      if (!this.dealerId) return {};

      let items = {
        datePickerStep: "",
        schedule: null,
      };

      items.datePickerStep = 60;
      items.schedule = this.dealerTimeItems;

      return items;
    },
  },

  watch: {
    city: {
      handler() {
        console.log("val city");
        // if (this.dealerItems.length === 1) {
        // this.form.dealer_id = this.dealerItems[0].value
        // }
      },
    },
  },

  created() {
    this.getParams();
    const lang = window.location.pathname;
    const url = lang.split("/");
    const locale = url[1];
    this.locale = locale;

    this.maskNumber =
      locale == "ro" || locale == "ru"
        ? "+###########"
        : "+380-##-###-##-##";

    if (locale.length > 0) {
      this.getUrl = `${config.API}${lang}/vin`;
    } else {
      this.getUrl = `${config.API}/vin`;
    }
    axios.get(this.createUrl(`/service/${this.win}`)).then(async (res) => {
      this.data = res.data;

      if (this.data.methods && this.data.methods.length > 0) {
        const phone = this.data.methods.find(m => m.id === 'Phone') || this.data.methods[0];
        this.selectedMethod = phone;
        this.methodsId = phone.id;
      }

      await this.$nextTick();
      if (this.queryCity !== "") this.changeCity({ id: this.queryCity });
    });
  },

  mounted () {
    tokens.X = { pattern: /[+\d]/, transform: v => v }
  },

  methods: {
    getParams() {
      const params = window.location.search.substring(1);
      const vars = params.split("&");
      vars.forEach((query) => {
        const resultArr = query.split("=");
        if (resultArr[0] === "city") this.queryCity = Number(resultArr[1]);
        else if (resultArr[0] === "dealer")
          this.queryDealer = Number(resultArr[1]);
        this.dealerId = Number(resultArr[1]);
      });
    },
    createUrl(arg) {
      const searchVal = window.location.search;
      return `${this.getUrl}${arg}${searchVal}`;
    },
    openModal(e) {
      if (e.target.classList.contains("open-modal")) {
        (this.popupContent = this.data.popup), (this.showModal = true);
      }
      if (e.target.classList.contains("open-marketing-modal")) {
        (this.popupContent = this.data["popup-marketing"]),
          (this.showModal = true);
      }
    },
    async changeCity(e) {
      this.$refs.dillerDropdown.clear();
      this.isActive = false;
      if (e == null) {
        this.cityId = null;
        return;
      }
      this.cityId = e.id;
      this.dealerData = await axios.get(
        this.createUrl(`/dealer/${this.cityId}`)
      );
      this.dillersArray = this.dealerData.data;
      this.$refs.datePickerDefault.date = "";
      this.$refs.datePickerDefault.time = "";
      this.$refs.datePicker.date = "";
      this.$refs.datePicker.time = "";
      this.dateAndTime = "";
      if (this.queryDealer !== "") this.getDealerId({ id: this.queryDealer });

      if (this.dillersArray.length === 1) {
        this.getDealerId(this.dillersArray[0]);
      }
    },

    async getDealerId(e) {
      if (e == null) {
        this.dealerId = null;
        return;
      }
      this.dealerId = e.id;

      // get work time this.dealer
      const { data } = await axios
        .get(this.createUrl(`/requested-time/${this.dealerId}`))
        .catch((e) => console.warn("Fetch Dealer error", { e }));
      this.dealerTimeItems = data;
      this.$refs.datePickerDefault.date = "";
      this.$refs.datePickerDefault.time = "";
      this.$refs.datePicker.date = "";
      this.$refs.datePicker.time = "";
      this.dateAndTime = "";
      this.disabledCalendar = false;
      this.marginHidden = false;
    },

    getMethodsId(e) {
      this.selectedMethod = e;
      if (e == null) {
        this.methodsId = null;
        return;
      }
      this.methodsId = e.id;
    },
    changeAppeal(e) {
      if (e == null) {
        this.appealId = null;
        return;
      }
      this.appealId = e.id;
    },
    checkboxValue(e) {
      if (e == true) {
        this.checkVal = 1;

        return this.checkVal;
      } else if (e == false) {
        this.checkVal = 0;
      }
    },
    checkboxMarketingValue(e) {
      if (e == true) {
        this.checkMarketingVal = 1;

        return this.checkMarketingVal;
      } else if (e == false) {
        this.checkMarketingVal = 0;
      }
    },
    async submit() {
      this.sendData = new FormData();
      this.inputs = [];
      const inputs = this.$refs.form.querySelectorAll("input");
      this.inputs = Array.from(inputs);
      for (let i = 0; i < this.inputs.length; i++) {
        if (this.inputs[i].hasAttribute("name")) {
          this.sendData.append(
            this.inputs[i].getAttribute("name"),
            this.inputs[i].value
          );
        } else if (this.inputs[i].hasAttribute("comment")) {
          this.sendData.append(
            this.inputs[i].getAttribute("comment"),
            this.inputs[i].value
          );
        }
      }
      this.sendData.append("city", this.cityId);
      this.sendData.append("dealer", this.dealerId);
      this.sendData.append("method", this.methodsId);
      this.sendData.append("appeal", this.appealId);
      this.sendData.append("agreement", this.checkVal);
      this.sendData.append("marketing", this.checkMarketingVal);
      this.sendData.append("requested_time", this.dateAndTime);
      if (this.formInfoItems != undefined) {
        this.sendData.append("campaign", JSON.stringify(this.formInfoItems));
      }

      if (this.hint) {
        this.sendData.append("hint", JSON.stringify(this.hint));
      } else this.sendData.append("hint", '"не задано"');

      let params = {};
      if (
        this.$route.query.dealerId ||
        this.$route.query.dealerName ||
        this.$route.query.dealer
      ) {
        params = {
          iframe: 1,
        };
      }

      axios
        .post(this.createUrl(`/service/${this.win}`), this.sendData, {
          params,
        })
        .then((res) => {
          const { data } = res;
          this.$emit("refresh", data);
          window.dataLayer.push({ event: "servicevin" });
        })
        .catch((err) => {
          this.errors = err.response.data;
        });
    },
  },
};
</script>
<style lang="sass">
@import '../assets/sass/partials/_sass-components.sass'
.service-request
  padding-bottom: 30px
  position: relative
  &.active-modal
    overflow: hidden
    height: 100vh
  &__form
    border-top: 1px solid #e4e4e4
    padding: 24px 0 0
    +res('mob')
      padding-top: 10px
      margin-top: 30px
  &__comment
    sup
      display: none
    .vin-label__error
      bottom: -31px
      text-align: left
      +res('mob')
        bottom: -34px
  &__car-number
    .vin-label__error
      +res('mobXs')
        white-space: nowrap
  &__info-block
    margin-bottom: 40px
    +res('mob')
      margin-bottom: 20px
    &_label
      font-family: $text-font
      font-size: 15px
      line-height: 1.38
      color: $black
    &_number
      font-family: $text-font
      font-size: 21px
      line-height: 1.33
      color: $black
  &__form-col
    display: flex
    //flex-direction: column
    flex-wrap: wrap
    justify-content: space-around
    @media only screen and (max-width: 1200px)
      flex-direction: column
    &:nth-child(2)
      // padding-top: 105px
      +res('tab')
        padding-top: 0
    +res('tab')
      width: 100%
      align-items: center
  &__form-row.split
    margin-bottom: 40px
    margin-top: 40px
    +res('mob')
      margin: 22px 0 40px
  &__form-btn
    &_margin-for-calendar
      margin-bottom: 350px
  .split2
    display: flex
    justify-content: space-around
    +res('tab')
      flex-wrap: wrap
  &__form-input
    &_lgDown
      display: none !important
      +res('tab')
        display: block !important
    &_lgUp
      +res('tab')
        display: none !important
  .open-modal
    border: none
    background-color: transparent
    padding: 0
    cursor: pointer
    text-decoration: underline
  .open-marketing-modal
    border: none
    background-color: transparent
    padding: 0
    cursor: pointer
    text-decoration: underline
</style>
